import { Directive, inject } from '@angular/core';
import { DepotFacade } from '@zero/depot/domain';

@Directive()
export class FirstSavingsPlanTeaserBase {
  public readonly depotFacade = inject(DepotFacade);

  public dismiss(): void {
    this.depotFacade.dismissSavingsPlanTeaser();
  }
}
